import type { RootState } from "../reducers/root.reducer"
import type { IIntakeDemoState } from "../types/state.types"

export const intakeDemoSelector = (state: RootState): IIntakeDemoState =>
    state.intakeDemo
